import React from "react";
import { useNavigate } from "react-router-dom";

const Wallet = ({ onCancel }) => {
  const navigate = useNavigate();
  const onClickHandler = () => {
    navigate("/wallet");
    onCancel();
  };
  return (
    <div
      className="flex text-xs font-medium py-1 pl-8"
      onClick={onClickHandler}
    >
      <img className="w-3 h-4 pt-1 mr-3 " src="/images/Wallet.png" alt="" />
      Wallet
    </div>
  );
};
export default Wallet;
